import { render } from "./JournalCirculation.vue?vue&type=template&id=ec5c309a&scoped=true"
import script from "./JournalCirculation.vue?vue&type=script&lang=js"
export * from "./JournalCirculation.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec5c309a"]])

export default __exports__